import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import { Switch, Route, BrowserRouter } from "react-router-dom";
import { ProtectedRoute } from "./route/protected.route";
import { loadUser } from "./store/actions/AuthActions";
// for authentication
import Login from "./pages/auth/Login";
import Signup from "./pages/auth/Signup";
import SendLink from "./pages/auth/SendLink";
import Reset from "./pages/auth/Reset";
import Logout from "./layouts/Logout";
// for dashboards
import Home from "./pages/dashboard/Home";
import SettingsAccount from "./pages/dashboard/SettingsAccount";
import Services from "./pages/dashboard/Services";
import Beneficiries from "./pages/dashboard/Beneficiries";
import Academics from "./pages/dashboard/Academics";
import Insurance from "./pages/dashboard/Insurance";
import Assocciations from "./pages/dashboard/Assocciations";
import ViewAssocciation from "./pages/dashboard/ViewAssocciation";
import Residence from "./pages/dashboard/Residence";
import Categories from "./pages/dashboard/Categories";
import Stock from "./pages/dashboard/Stock";
import ViewStock from "./pages/dashboard/ViewStock";
import Caregiver from "./pages/dashboard/Caregivers";
import School from "./pages/dashboard/School";
import Events from "./pages/dashboard/Events";
import ViewEvent from "./pages/dashboard/ViewTest";
import ViewSaturday from "./pages/dashboard/ViewSaturday";
import Funds from "./pages/dashboard/Funds";
import ViewFund from "./pages/dashboard/ViewFund";
// import Letters from "./pages/dashboard/Letters";
import BenEconomic from "./pages/dashboard/BenEconomic";
import BenProfile from "./pages/dashboard/BenProfile";
import ViewVisits from "./pages/dashboard/ViewVisits";
import ViewMeeting from "./pages/dashboard/ViewMeeting";
import ViewAnnualEvent from "./pages/dashboard/AnnualEvent";
import Notifications from "./pages/dashboard/Notification";
import NotFound from "./layouts/NotFound";
import Project from "./pages/dashboard/Project";
function App() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(loadUser());
  }, [dispatch]);
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/" exact>
          <Login />
        </Route>

        <Route path="/register">
          <Signup />
        </Route>
        <Route path="/resetlink">
          <SendLink />
        </Route>
        <Route path="/reset">
          <Reset />
        </Route>
        <ProtectedRoute path="/workspaces" component={Project} />
        <ProtectedRoute path="/home" component={Home} />
        <ProtectedRoute path="/settings" component={SettingsAccount} />

        <ProtectedRoute path="/services" component={Services} exact />

        <ProtectedRoute
          path="/services/beneficiaries/profile/:benId"
          component={BenProfile}
        />

        <ProtectedRoute
          path="/services/beneficiries"
          exact
          component={Beneficiries}
        />

        <ProtectedRoute path="/logout" component={Logout} exact />

        <ProtectedRoute path="/academics" component={Academics} exact />

        <ProtectedRoute path="/insurances" component={Insurance} exact />

        <ProtectedRoute
          path="/assocciations/:assocciationid"
          component={ViewAssocciation}
        />

        <ProtectedRoute path="/assocciations" component={Assocciations} exact />

        <ProtectedRoute
          path="/services/residences"
          component={Residence}
          exact
        />

        <ProtectedRoute
          path="/services/categories"
          component={Categories}
          exact
        />

        <ProtectedRoute
          path="/services/stock/:stockId"
          component={ViewStock}
          exact
        />

        <ProtectedRoute
          path="/services/economy"
          component={BenEconomic}
          exact
        />

        <ProtectedRoute path="/services/stock" component={Stock} exact />

        <ProtectedRoute
          path="/services/caregivers"
          component={Caregiver}
          exact
        />

        <ProtectedRoute path="/services/schools" component={School} exact />

        <ProtectedRoute path="/services/events" component={Events} exact />

        <ProtectedRoute
          path="/services/events/assessment/:eventid"
          component={ViewEvent}
          exact
        />

        <ProtectedRoute
          path="/services/events/saturday/:eventid"
          component={ViewSaturday}
          exact
        />

        <ProtectedRoute
          path="/services/events/visits/:eventid"
          component={ViewVisits}
          exact
        />

        <ProtectedRoute
          path="/services/events/meeting/:eventid"
          component={ViewMeeting}
        />
        <ProtectedRoute
          path="/services/events/annualevent/:eventid"
          component={ViewAnnualEvent}
        />

        <ProtectedRoute path="/services/funds" component={Funds} exact />

        <ProtectedRoute path="/services/funds/:fundId" component={ViewFund} />

        {/* <ProtectedRoute path="/services/letters" component={Letters} exact /> */}

        <Route path="*" component={NotFound} />

        <ProtectedRoute
          path="/services/notifications"
          component={Notifications}
          exact
        />
      </Switch>
    </BrowserRouter>
  );
}

export default App;
